var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompliance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_289_410)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 29.75C25.6 29.75 25.2 29.72 24.82 29.65C22.7 29.34 20.77 28.12 19.55 26.31C18.7 25.03 18.25 23.54 18.25 22C18.25 17.73 21.73 14.25 26 14.25C30.27 14.25 33.75 17.73 33.75 22C33.75 23.54 33.3 25.03 32.45 26.31C31.22 28.13 29.29 29.34 27.15 29.66C26.8 29.72 26.4 29.75 26 29.75ZM26 15.75C22.55 15.75 19.75 18.55 19.75 22C19.75 23.25 20.11 24.45 20.79 25.47C21.78 26.93 23.33 27.91 25.05 28.16C25.69 28.27 26.32 28.27 26.91 28.16C28.66 27.91 30.21 26.92 31.2 25.46C31.88 24.44 32.24 23.24 32.24 21.99C32.25 18.55 29.45 15.75 26 15.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4698 35.59C20.3298 35.59 20.1998 35.57 20.0598 35.54C19.4098 35.39 18.9098 34.89 18.7598 34.24L18.4098 32.77C18.3898 32.68 18.3198 32.61 18.2198 32.58L16.5698 32.19C15.9498 32.04 15.4598 31.58 15.2898 30.97C15.1198 30.36 15.2898 29.7 15.7398 29.25L19.6398 25.35C19.7998 25.19 20.0198 25.11 20.2398 25.13C20.4598 25.15 20.6598 25.27 20.7898 25.46C21.7798 26.92 23.3298 27.91 25.0598 28.16C25.6998 28.27 26.3298 28.27 26.9198 28.16C28.6698 27.91 30.2198 26.92 31.2098 25.46C31.3298 25.27 31.5398 25.15 31.7598 25.13C31.9798 25.11 32.1998 25.19 32.3598 25.35L36.2598 29.25C36.7098 29.7 36.8798 30.36 36.7098 30.97C36.5398 31.58 36.0398 32.05 35.4298 32.19L33.7798 32.58C33.6898 32.6 33.6198 32.67 33.5898 32.77L33.2398 34.24C33.0898 34.89 32.5898 35.39 31.9398 35.54C31.2898 35.7 30.6198 35.47 30.1998 34.96L25.9998 30.13L21.7998 34.97C21.4598 35.37 20.9798 35.59 20.4698 35.59ZM20.0898 27.03L16.7998 30.32C16.7098 30.41 16.7198 30.51 16.7398 30.57C16.7498 30.62 16.7998 30.72 16.9198 30.74L18.5698 31.13C19.2198 31.28 19.7198 31.78 19.8698 32.43L20.2198 33.9C20.2498 34.03 20.3498 34.07 20.4098 34.09C20.4698 34.1 20.5698 34.11 20.6598 34.01L24.4898 29.6C22.7898 29.27 21.2298 28.36 20.0898 27.03ZM27.5098 29.59L31.3398 33.99C31.4298 34.1 31.5398 34.1 31.5998 34.08C31.6598 34.07 31.7498 34.02 31.7898 33.89L32.1398 32.42C32.2898 31.77 32.7898 31.27 33.4398 31.12L35.0898 30.73C35.2098 30.7 35.2598 30.61 35.2698 30.56C35.2898 30.51 35.2998 30.4 35.2098 30.31L31.9198 27.02C30.7698 28.35 29.2198 29.26 27.5098 29.59Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8901 25.89C27.6301 25.89 27.3201 25.82 26.9501 25.6L26.0001 25.03L25.0501 25.59C24.1801 26.11 23.6101 25.81 23.4001 25.66C23.1901 25.51 22.7401 25.06 22.9701 24.07L23.2101 23.04L22.4101 22.3C21.9701 21.86 21.8101 21.33 21.9601 20.85C22.1101 20.37 22.5501 20.03 23.1701 19.93L24.2401 19.75L24.7501 18.63C25.0401 18.06 25.4901 17.74 26.0001 17.74C26.5101 17.74 26.9701 18.07 27.2501 18.64L27.8401 19.82L28.8301 19.94C29.4401 20.04 29.8801 20.38 30.0401 20.86C30.1901 21.34 30.0301 21.87 29.5901 22.31L28.7601 23.14L29.0201 24.07C29.2501 25.06 28.8001 25.51 28.5901 25.66C28.4801 25.75 28.2401 25.89 27.8901 25.89ZM23.6101 21.39L24.3001 22.08C24.6201 22.4 24.7801 22.94 24.6801 23.38L24.4901 24.18L25.2901 23.71C25.7201 23.46 26.3001 23.46 26.7201 23.71L27.5201 24.18L27.3401 23.38C27.2401 22.93 27.3901 22.4 27.7101 22.08L28.4001 21.39L27.5301 21.24C27.1101 21.17 26.6901 20.86 26.5001 20.48L26.0001 19.5L25.5001 20.5C25.3201 20.87 24.9001 21.19 24.4801 21.26L23.6101 21.39Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_289_410",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_289_410"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_289_410",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliance);
export default __webpack_public_path__ + "static/media/compliance.c91911bb59fcb147d9068a6c69fd9043.svg";
export { ForwardRef as ReactComponent };